/**
 * Build the API-bound `modularFilters` array from the three local lists used
 * by the analytics filter UIs (selected agents, agent-scoped filters, global
 * filters).
 *
 * Strips local-only fields (`id`, `agentId`, `_justAdded`, `sampleValues`)
 * and maps `source` to the legacy `propertyType` the backend SQL builder
 * still expects for fixed/custom/metadata branching.
 */
const asList = (v) => (Array.isArray(v) ? v : []);

export default function buildModularFilters({ selectedAgents = [], agentScopedFilters = [], globalFilters = [] }) {
  const out = [];
  if (asList(selectedAgents).length > 0) {
    out.push({
      field: 'agent_name',
      operator: 'is',
      value: asList(selectedAgents).map((a) => a.agentName),
      category: 'agents',
    });
  }
  const clean = (f) => {
    const { id, agentId, _justAdded, sampleValues, ...rest } = f;
    const propertyType =
      rest.source === 'attributes' || rest.source === 'span_attributes'
        ? 'custom'
        : rest.source === 'metadata'
          ? 'metadata'
          : rest.source === 'user'
            ? 'custom'
            : 'fixed';
    return { ...rest, propertyType };
  };
  // A list that is not a list (a stray setter value) contributes nothing rather than crashing the page.
  out.push(...asList(agentScopedFilters).map(clean));
  out.push(...asList(globalFilters).map(clean));
  return out;
}
